module.exports = __webpack_public_path__ + "img/store.b5731f6.png";